export default {
  prefix: '',
  suffix: '',
  thousands: ',',
  decimal: '.',
  precision: 2
}



// WEBPACK FOOTER //
// ./src/v-money/options.js